import { useMemo } from "react";
import { useSelector } from "react-redux";

import { getTeacherSubjects } from "seneca-common/features/user/state/selectors/userInfo";

import useSubjectFilter from "features/common/hooks/useSubjectFilter";

export default function useSubjectDropdownOptions() {
  const { subjectsOptions: subjectsWithTagIds, tagsFetched } =
    useSubjectFilter();

  const defaultSubjects = useSelector(getTeacherSubjects);

  const defaultSubjectOptions = useMemo(() => {
    if (!defaultSubjects) return [];

    return defaultSubjects.map(subject => ({
      label: subject,
      value: subject
    }));
  }, [defaultSubjects]);

  const dropdownOptions = useMemo(() => {
    return subjectsWithTagIds?.map(option => ({
      label: option.label,
      value: option.label
    }));
  }, [subjectsWithTagIds]);

  return {
    dropdownOptions,
    defaultSubjects,
    defaultSubjectOptions,
    isLoading: !tagsFetched
  };
}
